import trySaveMessage from 'owa-mail-compose-store/lib/actions/trySaveMessage';
var saveItem = function (viewState) { return function () {
    return trySaveMessage(viewState, /* autoSave */ false, /* rejectWhenFail */ true)
        .then(function () { return Promise.resolve(viewState.itemId.Id); })
        .catch(function () { return Promise.resolve(null); });
}; };
export default saveItem;
//# sourceMappingURL=saveItem.js.map